export var LGBTQIA_YEAR_OPTIONS = ["2022", "2023"];
export var LGBTQIA_SOURCE_URL = "https://www.ssp.pi.gov.br/wp-content/uploads/2025/06/SSP01_b85e1dbf31.pdf";
export var LGBTQIA_CARD_WIDTH_BY_YEAR = {
    "2022": {
        "Perfil racial da vítima": 6,
        "Estado civil da vítima": 6,
        "Meio Empregado para MVI": 6,
        "Distribuição da Natureza dos MVI": 6,
        "Ocupações mais registradas entre as vítimas": 6,
    },
    "2023": {
        "Análise bivariada da cor da pele e faixa etária (%) (exceto MVIS)": 6,
        "Análise bivariada crimes e motivação": 6,
        "Cor da pele das vítimas (exceto MVIS)": 6,
        "Cor da pele das vítimas de MVIS": 6,
        "Frequência absoluta dos grupos de natureza (exceto MVIS)": 6,
        "Tipo de local (exceto MVIS)": 6,
        "Motivações de crimes": 6,
        "Tipo de local das MVIS": 6,
    },
};
